<template>
    <v-card style="min-height:400px">
        <v-card-title class="pb-0 " v-if="!this.date">
          
            <v-icon class="ml-1" @click="getItems()">mdi-refresh</v-icon>
        </v-card-title>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <v-card-text>
            <!-- <h4>My Day</h4> -->
            <div class="d-flex justify-space-between align-center mb-2">
                <div v-if="schedule && schedule.start && schedule.end" class="grey--text text--darken-1">
                    Schedule:
                        <span>{{ $formattedTime(schedule.start) }}</span> -
                        <span v-if="endTime > schedule.end && ['ali.nihadh', 'mohamed.shaffanu'].includes(User.username)">{{  $formattedTime(endTime) }}</span>
                        <span v-else>{{ $formattedTime(schedule.end) }}</span>
                    <div class="red--text" v-if="hours.late">
                        Late: {{ hours.late }}
                    </div>
                </div>
                <div>
                    <v-chip v-if="attedance_label" x-small color="info" class="text-uppercase font-weight-bold">
                        {{attedance_label}}
                    </v-chip>
                </div>
            </div>

            <div class="row justify-space-around">
                <div class="col-3 px-1" v-if="percents && percents.worked">
                    <percent-chart
                        v-if="!hours.is_holiday"
                        title="Work"
                        height="100"
                        :percent="percents.worked.percent"
                        mainColor="#4c4"
                        accentColor="#afa"
                    ></percent-chart>
                    <div v-else style="height:100px;display:flex;align-items:center;justify-content:center;font-size:0.85em;color:#777">Work</div>
                    <div style="font-size:1.2em;font-weight:600" class="grey--text text--darken-3 text-center">{{ hours.worked || '00:00' }}</div>
                    <div v-if="hours.feeding" class="caption pink--text text--darken-2 text-center">incl. {{ hours.feeding }} child care</div>
                </div>

                <div class="col-3 px-1" v-if="percents && percents.break && !hours.is_holiday && !hours.is_onleave">
                    <percent-chart
                        title="Break"
                        height="100"
                        :percent="percents.break.percent"
                        mainColor="#dd2"
                        accentColor="#ff9"
                    ></percent-chart>
                    <div style="font-size:1.2em;font-weight:600" class="grey--text text--darken-3 text-center">{{ hours.break || '00:00' }}</div>
                </div>

                <div class="col-3 px-1 d-flex flex-column align-center" v-if="hours.courtOut">
                    <span style="font-size:1.7em;flex-grow:1;margin-top:23px" class="black--text">{{ hours.courtOut }}</span>
                    <div style="font-size:0.85em;margin-bottom:5px">Court Out</div>
                </div>

                <div class="col-3 px-1 d-flex flex-column align-center" v-if="hours.officialOut">
                    <span style="font-size:1.7em;flex-grow:1;margin-top:23px" class="black--text">{{ hours.officialOut }}</span>
                    <div style="font-size:0.85em;margin-bottom:5px">Official Out</div>
                </div>
            </div>


            <div class="d-flex align-center mb-1">
                <h4 class="mr-2">Card Logs</h4>
            </div>
            <div>
                <v-simple-table fixed-header dense height="170px">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Time</th>
                            <th>Machine/Door</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="log in myInOutLogs" :key="log.id"
                            :class="{'red--text': log.use_status === 'cancelled', 'grey--text': log.log_only}"
                            :title="log.cancel_reason ? 'Cancelled: ' + log.cancel_reason.replace(/_/g, ' ') : undefined">
                            <td class="px-1" style="width:50px">
                                <v-icon v-if="log.door" :color="log.log_only ? 'grey' : 'blue'">mdi-door</v-icon>
                                <v-icon v-else-if="log.machine" :color="['In','check_in'].includes(log.in_out) ? 'green' : 'red'">
                                    mdi-credit-card-clock-outline
                                </v-icon>
                                <template v-if="!log.log_only">
                                    <v-icon small v-if="['In','check_in'].includes(log.in_out)" color="green">mdi-arrow-left</v-icon>
                                    <v-icon small v-if="['Out','check_out','personal_out','official_out','court_out'].includes(log.in_out)" color="red">mdi-arrow-right</v-icon>
                                </template>
                            </td>
                            <td class="px-1">{{ log.time }}</td>
                            <td class="px-1">{{ log.machine ? log.machine+' Machine' : log.door }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>

            <div v-if="$can('hrms') && staff_id" class="mt-2">
                <div class="text-center grey--text mb-1" style="font-size:0.75em">
                    This will only effect the current selected staff
                </div>
                <div class="d-flex flex-wrap justify-center">
                    <v-btn x-small outlined color="primary" class="mr-1 mb-1" @click="runProcessAttLog">
                        <v-icon x-small left>mdi-cog-sync</v-icon>Process
                    </v-btn>
                    <v-btn x-small outlined color="teal" class="mr-1 mb-1" @click="runSyncInOut">
                        <v-icon x-small left>mdi-database-sync</v-icon>Sync
                    </v-btn>
                    <v-btn x-small outlined color="green" class="mb-1" @click="$emit('add-log')">
                        <v-icon x-small left>mdi-plus</v-icon>Add Log
                    </v-btn>
                </div>
            </div>

        </v-card-text>

        <cron-console-modal ref="cronConsole" @done="getItems" />
    </v-card>
</template>

<script>
// import PercentChart from '../charts/PercentChart.vue'
import PercentChart from '../charts/am5PercentChart.vue'
import CronConsoleModal from '../shared/CronConsoleModal.vue'

export default {
    components: {
        PercentChart,
        CronConsoleModal,
    },
    data: () => ({
        myInOutLogs: [],
        loading: 0,
        percents: null,
        hours: {},
        schedule: null,
        requestParams: {},
        endTime: null,

        attedance_label: '',
    }),

    props: {
        date: {
            default: null,
        },
        staff_id: {
            default: null,
        }
    },
    watch: {
        date: {
            handler: function() {
                if(this.date)
                    this.getItems()
            },
            immediate: true
        },
        staff_id: {
            handler: function() {
                if(this.staff_id)
                    this.getItems()
            },
            immediate: true
        }
    }, 

    methods: {
        getItems(){
            this.getMyInOutLogs()
            this.getMyDay()
        },
        minsToHM(mins) {
            if (mins == null) return null
            const h = Math.floor(mins / 60)
            const m = Math.floor(mins % 60)
            return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
        },
        currentDate() {
            return this.date || new Date().toISOString().slice(0, 10)
        },
        runProcessAttLog() {
            this.$refs.cronConsole.run('process:att-log', {
                job:         'process-att-log',
                from:        this.currentDate(),
                to:          this.currentDate(),
                staff_ismid: this.staff_id || this.$store?.state?.User?.staff?.ISMID,
                reprocess:   true,
            })
        },
        runSyncInOut() {
            this.$refs.cronConsole.run('sync:att-log-inout', {
                job:         'sync-att-log-inout',
                from:        this.currentDate(),
                to:          this.currentDate(),
                staff_ismid: this.staff_id || this.$store?.state?.User?.staff?.ISMID,
                reprocess:   true,
            })
        },
        getMyInOutLogs(){
            this.date ? (this.requestParams.date = this.date) : delete this.requestParams.date;
            this.staff_id ? (this.requestParams.staff_id = this.staff_id) : delete this.requestParams.staff_id;
            this.loading++;
            return this.$axios.get(`/api/attendance/in-out-logs/staff`, {params : this.requestParams}).then(res => {
                this.myInOutLogs = res.data
            }).finally(() => this.loading--)
        },
        getMyDay(){
            this.loading++
            this.date ? (this.requestParams.date = this.date) : delete this.requestParams.date;
            this.staff_id ? (this.requestParams.staff_id = this.staff_id) : delete this.requestParams.staff_id;

            return this.$axios.get(`/api/dashboard/my-day`, {params : this.requestParams}).then(res => {
                // this.myDay = res.data
                this.schedule = res.data.schedule
                this.endTime = res.data.end_time
                this.percents = {
                    worked: {
                        percent: res.data.percent_work
                    },
                    break: {
                        percent: res.data.percent_break
                    }
                }
                this.hours = {
                    worked: this.minsToHM(res.data.mins_work),
                    feeding: res.data.mins_feeding ? this.minsToHM(res.data.mins_feeding) : null,
                    break: this.minsToHM(res.data.mins_break),
                    officialOut: res.data.official_out_hours,
                    courtOut: res.data.court_out_hours,
                    late: res.data.late_hours,
                    is_holiday: res.data.is_holiday,
                    is_onleave: res.data.on_leave
                }

                this.attedance_label = res.data.attendance_label	
                // console.log(this.hours)
            }).finally(() => this.loading--)
        }
    },
    mounted(){
        this.getItems()
    }
}
</script>